
import { useContext } from 'react';

import ExpandableMapControl from 'core/ui/mapping/expandable-map-control';
import PeopleTypeLayers from 'partials/map-layers/people-type-layers';
import BoundariesLayers from 'partials/map-layers/boundaries-layers';
import LocationsLayers from 'partials/map-layers/locations-layers';
import SessionContext from 'SessionContext'

const MapLayers = (props) => {
  const context = useContext(SessionContext);
  const peopleTypeLayerDisabled = props.disablePeopleLayer === "true";
  const locationTypeLayerDisabled = props.disableLocationTypeLayer === "true";
  const addLocationsToCrossFilter = props.addLocationsToCrossFilter === "true";
  const boundariesLayerDisabled = props.disableBoundariesLayer === "true";
  const chartsStore = context.chartsStore;
  const map = props.map;

  if(!chartsStore.loaded || !map) return null;

  return (
    <ExpandableMapControl openButton={<i className='fa fa-layer-group' />}>
      <div className='map-layers'>
        <header>
          <i className='fa fa-layer-group' />
          <h3>Layers</h3>
        </header>
        <div className='layers-list'>
          { !peopleTypeLayerDisabled && <PeopleTypeLayers map={map} />}
          {!locationTypeLayerDisabled && props.showLocations && 
            <LocationsLayers 
              map={map} 
              show={props.showLocations} 
              addLocationsToCrossFilter={addLocationsToCrossFilter}
            />
          }
          {!boundariesLayerDisabled && props.showLocations && 
            <BoundariesLayers 
              map={map} 
              show={props.showLocations} 
            />
          }
        </div>
      </div>
    </ExpandableMapControl>
  );
}
export default MapLayers;
